import { DATA_FILES, type ContentLanguage } from "./manifest";
import type { TreesDocument } from "./types";

async function fetchJson<T>(url: string, what: string): Promise<T> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Could not load the ${what} (${response.status}).`);
  }
  return (await response.json()) as T;
}

export function loadTrees(): Promise<TreesDocument> {
  return fetchJson<TreesDocument>(DATA_FILES.trees, "tree data");
}

export function loadContent(language: ContentLanguage): Promise<Record<string, string>> {
  return fetchJson<Record<string, string>>(DATA_FILES.content[language], `${language} text`);
}
